export default "__VITE_ASSET__Dez1$Yi1__"